export enum ProjectAction {
    UPDATE_LOADING = "UPDATE_LOADING",
    ADD_PROJECT_LIST = "ADD_PROJECT_LIST",
    UPDATE_PROJECT_LIST = "UPDATE_PROJECT_LIST",
    UPDATE_PROJECT_SEARCH_REQ = "UPDATE_PROJECT_SEARCH_REQ",
    UPDATE_EMPLOYEE_LIST = "UPDATE_EMPLOYEE_LIST",
    UPDATE_BUILDER_LIST = "UPDATE_BUILDER_LIST",
    UPDATE_LOCALITY_LIST = "UPDATE_LOCALITY_LIST",
    UPDATE_AMENITIES_LIST = "UPDATE_AMENITIES_LIST"
}